import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import {
  HIDE_REQUEST_SUCCESS,
  SHOW_REQUEST_SUCCESS
} from '../constants/mutation-types';

@Module({ namespaced: true, name: 'SuccessModuel' })
export default class SuccessModule extends VuexModule {
  public hasSuccessRequest: boolean = false;
  public successText: string = 'Request Successful!';

  @Mutation
  public [SHOW_REQUEST_SUCCESS](): void {
    this.hasSuccessRequest = true;
  }
  @Mutation
  public [HIDE_REQUEST_SUCCESS](): void {
    this.hasSuccessRequest = false;
  }
}
